import { makeStateKey, TransferState } from "@angular/platform-browser";
import { MlpHelper } from "../shared/mlpHelper";
import { DateService } from "../shared/date.service";
import * as i0 from "@angular/core";
import * as i1 from "@angular/platform-browser";
import * as i2 from "../shared/date.service";
var SEARCHDATA = makeStateKey("searchData");
var SearchService = /** @class */ (function () {
    function SearchService(transferState, dateService) {
        this.transferState = transferState;
        this.dateService = dateService;
        this.initSearchResultsPage = true;
        this.initialLoading = true;
        this.loading = true;
        this.radius = "";
        this.page = 1;
        this.perPage = 10;
        this.searchResultsOnlineOnly = 0;
        this.showMap = false;
        this.allowSearchAndMove = false;
        this.venuesOnMap = [];
        this.timeSearchSports = ["football", "badminton", "tennis", "squash"];
        this.autoCompleteSearchNoResults = false;
        this.allowMapIdle = true;
        this.filters = {
            online_booking: false,
            is_partner: false,
        };
        var searchData = this.transferState.get(SEARCHDATA, undefined);
        if (searchData)
            this.searchResults = searchData;
    }
    SearchService.prototype.isApprovedSport = function (sport) {
        return !!this.timeSearchSports.filter(function (item) { return item === sport; })[0];
    };
    SearchService.prototype.createInitialDates = function (year, month, day, hour, minute) {
        var time = this.dateService.createFilterTime(hour, minute);
        var date = this.dateService.createFilterDate(year, month, day);
        var incrementHours = 3;
        switch (hour) {
            case 21:
                incrementHours = 2;
                break;
            case 22:
                incrementHours = 1;
                break;
            case 23:
                incrementHours = 0;
                break;
            default:
                incrementHours = 3;
        }
        var endTime = this.dateService.createFilterTime(hour + incrementHours, 0);
        var endDate = this.dateService.createFilterDate(year, month, day);
        return { time: time, date: date, endTime: endTime, endDate: endDate };
    };
    SearchService.prototype.getVenuesWithRelationshipToResults = function (pitchCollection) {
        var venues = [];
        if (pitchCollection.data.length > 0) {
            pitchCollection.included.forEach(function (venue) {
                var newVenue = venue;
                newVenue.relationships.pitches.data = [];
                pitchCollection.data.forEach(function (pitch) {
                    var venueId = pitch.relationships.venues.data.id;
                    if (venueId == venue.id) {
                        newVenue.relationships.pitches.data.push(pitch);
                    }
                });
                venues.push(newVenue);
            });
        }
        return venues;
    };
    SearchService.prototype.sortAgg = function (items) {
        return items.sort(function (one, two) {
            return MlpHelper.sortAlphaNum(one.key, two.key);
        });
    };
    SearchService.prototype.reset = function () {
        this.searchResults = undefined;
        this.initialLoading = false;
        this.loading = false;
    };
    SearchService.prototype.closeLastMapMarkerPopup = function () {
        if (this.lastMapMarkerPopup !== null &&
            this.lastMapMarkerPopup !== undefined) {
            if (this.lastMapMarkerPopup)
                this.lastMapMarkerPopup.close();
            this.lastMapMarkerPopup = undefined;
        }
    };
    SearchService.ngInjectableDef = i0.defineInjectable({ factory: function SearchService_Factory() { return new SearchService(i0.inject(i1.TransferState), i0.inject(i2.DateService)); }, token: SearchService, providedIn: "root" });
    return SearchService;
}());
export { SearchService };
